<template>
  <div class="basic-block block-sell" :style="styles">
    <div class="content-wrap">
      <div class="block-sell__inner">
        <div class="block-sell__headline">好評発売中</div>
        <div class="block-sell__box">
          <div class="block-sell__list">
            <img src="/static/img/recommend/lp/kurenotori/book.png" alt="" class="block-sell__img" width="75">
            <div class="block-sell__info">
              <p class="block-sell__title">暮れの酉の繊細な人のための鳳凰数術占い - 名前と生年月日でわかる生きやすくなるための方法</p>
              <p class="block-sell__text"><b>出版社 : </b>ワニブックス</p>
              <p class="block-sell__text"><b>発売日 : </b>2022/3/24</p>
              <p class="block-sell__text"><b>単行本 : </b>ソフトカバー / 160ページ</p>
            </div>
          </div>
           <div class="block-sell__list">
            <img src="/static/img/recommend/lp/kurenotori/stump.png" alt="" class="block-sell__img" width="80">
            <div class="block-sell__info">
              <p class="block-sell__title">暮れの酉の鳳凰数術×すぐる画伯 スタンプ</p>
              <p class="block-sell__text"><b>【出版記念】</b>書籍イラストを担当されたすぐる画伯さん作、鳳凰数術キャラクターのLINEスタンプです。LINE STOREからお求めいただけます。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockSell',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      require: true,
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    link (e) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-book`,
      })
      window.open(this.$handoverParams(e.currentTarget.href), '_blank');
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

// 上限付きのレスポンシブなサイズを返す（$size は、width = 375px 時の大きさ）
@function responsive-size($size) {
  @return Min(($size / 375) * 100vw, $size * 1.2px );
}

.block-sell {
  background: #F3FEFF;
  padding-bottom: 60px;
  &__inner {
    padding: 0 20px;
  }
  &__headline {
    font-weight: 600;
    font-size: responsive-size(15);
    line-height: 1.4;
    text-align: center;
    color: #FFFFFF;
    background: $l_col_keycolor;
    border-radius: 10px 10px 0px 0px;
    padding: 7px 0 6px;
  }
  &__box {
    background: #FFFFFF;
    border: 1px solid #DADADA;
    border-radius: 0 0 10px 10px;
    padding: 0 16px;
  }
  &__list {
    display: flex;
    padding: 20px 0;
    border-bottom: 1px solid #DADADA;
    &:last-of-type { border: none; }
  }
  &__img {
    flex: 0 1 75px;
    align-self: center;
    margin: 0 15px 0 0;
  }
  &__info {
    flex: 1 1 auto;
  }
  &__title {
    font-weight: 600;
    font-size: responsive-size(14);
    line-height: 1.29;
    margin: 0 0 8px;
  }
  &__text {
    font-size: responsive-size(12);
    line-height: 1.25;
    text-align: justify;
    margin: 0;
    > b {
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockSell.vue